/* unplugin-vue-components disabled */import script from "./AppleSignInButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppleSignInButton.vue?vue&type=script&setup=true&lang=js"

import "./AppleSignInButton.vue?vue&type=style&index=0&id=6534d3cd&lang=scss"

const __exports__ = script;

export default __exports__